/**
 * Draft/publish readiness warnings for Ruler Measurement — project settings context.
 * Invoked only via uiRegistry (key `ruler-measurement`); inspects annotationUI.config only.
 *
 * Viewer-side copy for empty slots: "Add at least one measurement slot in project settings before annotating."
 * Here we point admins to the Annotation UI section of the same form.
 */

import { validateRulerConfig } from './rulerMeasurementModel';

export function getRulerMeasurementConfigPublishWarnings(annotationUI) {
    const issues = validateRulerConfig(annotationUI?.config);
    return issues.map((i) => i.message);
}
